import React from 'react';
import { MenuItem } from '@mui/material';
import fieldId from '../../../../hooks/fieldId';
import conditionId from '../../../../hooks/conditionId';
import { CustomSelectAndChildren } from '../../../../components/CustomSelectAndChildren';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import {TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import { EMPTY_VALUES } from '../../../../Apis/functions';
import RuleValueInput from './RuleValueInput';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const RuleRow = ({
    rule,
    attributesFilter,
    showDelete,
    onDelete,
    onFieldChange,
    onConditionChange,
    onValueChange,
    onDateChange,
    onFromDateChange,
    onToDateChange,
    onFromValueChange,
    onToValueChange,
    onAssignMultiple,
    onValidityChange,
}) => (
    <div className={"border-radius-8px background-shades-50 py-40px pr-0 pr-md-3 pr-lg-3 pr-xl-3"}>
        <div className="row align-items-center px-2">
            <div className="col-sm-12 col-md-3 px-1 mb-3 mb-md-0 mb-lg-0 mb-xl-0">
                <CustomSelectAndChildren
                    id={`slt_rr_field_${rule.id}`}
                    name="field"
                    trans="select_a_field"
                    value={rule.field}
                    onChange={(e) => onFieldChange(e.target.value)}
                    required={true}
                    emptyFields={rule.emptyFields }
                    showNoSelectionOption={false}
                    marginBottom={false}
                >
                    {attributesFilter?.map(attr => (
                        <MenuItem key={attr.id} value={attr.id}>
                            {fieldId(attr.id) || EMPTY_VALUES.DEFAULT}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>

            <div className="col-sm-12 col-md-3 px-1 mb-3 mb-md-0 mb-lg-0 mb-xl-0">
                <CustomSelectAndChildren
                    id={`slt_rr_cond_${rule.id}`}
                    name="condition"
                    trans="select_a_condition"
                    value={rule.condition}
                    disabled={!rule.field || rule.conditions.length === 0}
                    onChange={(e) => {
                        const cond = rule.conditions.find(c => c.id === e.target.value);
                        onConditionChange(e.target.value, cond?.operationKey || '');
                    }}
                    required={true}
                    showNoSelectionOption={false}
                    marginBottom={false}
                    emptyFields={rule.emptyFields && rule.field}
                >
                    {rule.conditions?.map(cond => (
                        <MenuItem key={cond.id} value={cond.id}>
                            {conditionId(cond.id) || EMPTY_VALUES.DEFAULT}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>

            <div className="col-sm-12 col-md-5 px-1 mb-3 mb-md-0 mb-lg-0 mb-xl-0">
                <RuleValueInput
                    rule={rule}
                    onValueChange={onValueChange}
                    onDateChange={onDateChange}
                    onFromDateChange={onFromDateChange}
                    onToDateChange={onToDateChange}
                    onFromValueChange={onFromValueChange}
                    onToValueChange={onToValueChange}
                    onAssignMultiple={onAssignMultiple}
                    onValidityChange={onValidityChange}
                />
            </div>

            <div className="col-sm-12 col-md-1 px-0 mb-3 mb-md-0 mb-lg-0 mb-xl-0">
                <div className={"d-flex justify-content-md-end"}>
                    {showDelete ? (
                        <ButtonIcon
                            id={`btn_rr_del_rule_${rule.id}`}
                            Icon={TrashOutlineIcon}
                            onClick={onDelete}
                            title=""
                            className="btn-outlined-error-600 w-40px h-40px minw-40px p-0"
                            iconProps={'btn-icon-svg-18px'}
                        />
                    ) : (
                        <div className="w-32px flex-shrink-0" />
                    )}
                </div>
            </div>
        </div>

    </div>
);

export default RuleRow;
